import { useRef, useState, useEffect, useCallback } from "react";

export interface SortDescriptor {
  column: string;
  direction: "ascending" | "descending";
}

export function useSortPanel(initialColumn: string) {
  const [sortDescriptor, setSortDescriptor] = useState<SortDescriptor>({
    column: initialColumn,
    direction: "descending",
  });
  const [isSortOpen, setIsSortOpen] = useState(false);
  const sortAnchorRef = useRef<HTMLDivElement>(null);
  const sortPanelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const update = () => {
      if (sortAnchorRef.current && sortPanelRef.current) {
        const rect = sortAnchorRef.current.getBoundingClientRect();
        sortPanelRef.current.style.top = `${rect.bottom + 8}px`;
        sortPanelRef.current.style.right = `${document.documentElement.clientWidth - rect.right}px`;
      }
    };

    if (isSortOpen) {
      update();
      // Перепозиционируем при скролле любого контейнера (capture=true)
      window.addEventListener("scroll", update, true);
      window.addEventListener("resize", update);
      return () => {
        window.removeEventListener("scroll", update, true);
        window.removeEventListener("resize", update);
      };
    }
  }, [isSortOpen]);

  const handleOutsideClick = useCallback((e: MouseEvent) => {
    if (
      sortPanelRef.current &&
      !sortPanelRef.current.contains(e.target as Node) &&
      sortAnchorRef.current &&
      !sortAnchorRef.current.contains(e.target as Node)
    ) {
      setIsSortOpen(false);
    }
  }, []);

  useEffect(() => {
    if (isSortOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isSortOpen, handleOutsideClick]);

  return {
    sortDescriptor,
    setSortDescriptor,
    isSortOpen,
    setIsSortOpen,
    sortAnchorRef,
    sortPanelRef,
  };
}
